import React from "react";
import { Box, Grid } from "@mui/material";
import MessageItem from "./MessageItem";
import { radii } from "../../../../theme/shape";

const MessageList = ({
  messages,
  onButtonsChange,
  channel,
  readOnly,
  hideMediaActions,
  highlightIncoming,
  onPickImage,
  onPickPdf,
  onReplaceMedia,
  onRemoveMedia,
  allowedButtonTypes,
  pixDefaults,
}) => {
  const isWhatsappLayout = channel === "whatsapp_api" || channel === "sms";

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        px: isWhatsappLayout ? 1 : 2,
        py: isWhatsappLayout ? 0.5 : 1,

        scrollbarWidth: "thin",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "text.disabled",
          borderRadius: radii.xs,
        },
      }}
    >
      <Grid container spacing={isWhatsappLayout ? 1.25 : 2}>
        {messages.map((message) => (
          <MessageItem
            key={message.id}
            message={message}
            onButtonsChange={onButtonsChange}
            channel={channel}
            readOnly={readOnly}
            hideMediaActions={hideMediaActions}
            highlightIncoming={highlightIncoming}
            onPickImage={onPickImage}
            onPickPdf={onPickPdf}
            onReplaceMedia={onReplaceMedia}
            onRemoveMedia={onRemoveMedia}
            allowedButtonTypes={allowedButtonTypes}
            pixDefaults={pixDefaults}
          />
        ))}
      </Grid>
    </Box>
  );
};

export default MessageList;
